module agi.expressions.card.utils{
    /**
     * General Utility functions
     */
    export class GeneralUtils{

        //Note: ideally, these constants would come from measuring the line height - but this produced better, 
        //but inconsistent browser scrolling between Chrome/Safari vs Firefox.
        /**
         * Height of a line in pixels. Used for cross-browser scrolling.
         * @see https://stackoverflow.com/questions/5527601/normalizing-mousewheel-speed-across-browsers/30134826#30134826
         */
        public static SCROLL_LINE_HEIGHT = 40;
        /**
         * Height of a page in pixels. Used for cross-browser scrolling.
         * @see https://stackoverflow.com/questions/5527601/normalizing-mousewheel-speed-across-browsers/30134826#30134826
         */
        public static SCROLL_PAGE_HEIGHT = 800;

        public static getRandomNumber(minNum, maxNum) : number{
            minNum = Math.ceil(minNum);
            maxNum = Math.floor(maxNum);
            return Math.floor(Math.random() * (maxNum - minNum)) + minNum;
        }
        public static approximately(a:number,b:number,epsilon:number=0.001): boolean{
            return Math.abs(a-b) <= epsilon;
        }
    }
}